<template>
    <div class="candidate-management-page">
        <!-- Page Header & Actions -->
        <div class="page-header-container d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">
            <div>
            </div>
            <div class="action-btn-wrapper">
                <el-dropdown trigger="click" @command="handleDropdownCommand">
                    <el-button type="primary" class="btn-action-main">
                        <i class="el-icon-setting mr-1"></i>
                        <span>Hành động</span>
                        <i class="el-icon-arrow-down el-icon--right ml-1"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown" class="custom-action-dropdown">
                        <el-dropdown-item command="add" v-if="checkTrainer">
                            <i class="el-icon-circle-plus-outline text-primary mr-2"></i>Thêm mới ứng viên
                        </el-dropdown-item>
                        <el-dropdown-item command="attendance">
                            <i class="el-icon-document-checked text-success mr-2"></i>Điểm danh học đào tạo
                        </el-dropdown-item>
                        <el-dropdown-item command="import" v-if="checkTrainer">
                            <i class="el-icon-upload2 text-warning mr-2"></i>Import dữ liệu Excel
                        </el-dropdown-item>
                        <el-dropdown-item command="export" v-if="checkTrainer">
                            <i class="el-icon-download text-info mr-2"></i>Export dữ liệu Excel
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>

        <div class="row">
            <div class="col-xl-12">
                <!-- Filter Section -->
                <div class="modern-card filter-card mb-4">
                    <div class="card-inner-body p-4">
                        <el-row :gutter="16" class="filter-controls-row" v-if="!checkStatusFilter">
                            <el-col :xs="24" :sm="12" :md="6" :lg="6" class="mb-3 mb-md-0">
                                <label class="filter-field-label">
                                    <i class="el-icon-search mr-1"></i> Ứng viên
                                </label>
                                <el-input
                                    type="text"
                                    clearable
                                    size="medium"
                                    v-model="form.keyword"
                                    class="w-100 modern-input"
                                    @input="getCandidate()"
                                    debounce="500"
                                    placeholder="Nhập mã, tên, SĐT, email..."
                                    prefix-icon="el-icon-search"
                                    autocomplete="false"
                                ></el-input>
                            </el-col>

                            <el-col :xs="24" :sm="12" :md="6" :lg="6" class="mb-3 mb-md-0">
                                <label class="filter-field-label">
                                    <i class="el-icon-s-operation mr-1"></i> Trạng thái ứng viên
                                </label>
                                <el-select
                                    v-model="form.status"
                                    class="w-100 modern-select"
                                    @change="getCandidate()"
                                    filterable
                                    clearable
                                    multiple
                                    collapse-tags
                                    placeholder="Tất cả trạng thái"
                                >
                                    <el-option
                                        v-for="item in statusCandidate"
                                        :key="item.id"
                                        :label="item.label"
                                        :value="item.id"
                                    >
                                        <span class="d-flex align-items-center">
                                            <span :class="['dot-indicator mr-2', 'dot-status-' + item.id]"></span>
                                            {{ item.label }}
                                        </span>
                                    </el-option>
                                </el-select>
                            </el-col>

                            <el-col :xs="24" :sm="12" :md="6" :lg="6" class="mb-3 mb-md-0">
                                <label class="filter-field-label">
                                    <i class="el-icon-office-building mr-1"></i> Văn phòng làm việc
                                </label>
                                <el-select
                                    v-model="form.branch_id"
                                    class="w-100 modern-select"
                                    filterable
                                    clearable
                                    multiple
                                    collapse-tags
                                    @change="getCandidate()"
                                    placeholder="Tất cả văn phòng"
                                >
                                    <el-option
                                        v-for="item in listBranch"
                                        :key="item.id"
                                        :label="item.name_alias ? item.name_alias : item.name"
                                        :value="item.id"
                                    >
                                        <span>{{ item.name_alias ? item.name_alias : item.name }}</span>
                                    </el-option>
                                </el-select>
                            </el-col>

                            <el-col :xs="24" :sm="12" :md="6" :lg="6" class="mb-0">
                                <label class="filter-field-label">
                                    <i class="el-icon-date mr-1"></i> Thời gian thêm ứng viên
                                </label>
                                <el-date-picker
                                    v-model="form.startDate"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    type="daterange"
                                    align="right"
                                    start-placeholder="Từ ngày"
                                    end-placeholder="Đến ngày"
                                    :picker-options="pickerStartOptions"
                                    @change="getCandidate"
                                    class="w-100 modern-date-picker"
                                ></el-date-picker>
                            </el-col>
                        </el-row>

                        <!-- Active Bulk Action Bar -->
                        <div class="bulk-action-banner d-flex align-items-center justify-content-between p-3 rounded" v-if="checkStatusFilter">
                            <div class="d-flex align-items-center flex-wrap gap-3">
                                <div class="bulk-badge">
                                    <i class="el-icon-circle-check mr-1"></i> Đã chọn <strong>{{ checkboxProp.length }}</strong> ứng viên
                                </div>
                                <el-select
                                    v-model="candidateActionValue"
                                    @change="changeStatusCandidate"
                                    placeholder="Chọn thao tác thực hiện..."
                                    size="medium"
                                    class="bulk-action-select"
                                >
                                    <el-option
                                        v-for="item in listAction"
                                        :key="item.id"
                                        :label="item.label"
                                        :value="item.id"
                                    >
                                        <span>{{ item.label }}</span>
                                    </el-option>
                                </el-select>
                            </div>
                            <div>
                                <el-button size="medium" class="btn-cancel-bulk" @click="closeCheckbox">
                                    <i class="el-icon-close mr-1"></i> Bỏ chọn
                                </el-button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Table Card -->
                <div class="modern-card table-card mb-4">
                    <div class="card-inner-body p-0">
                        <!-- Datatable start -->
                        <div class="candidate-table-wrapper custom-scrollbar">
                            <table class="candidate-modern-table">
                                <thead>
                                    <tr>
                                        <th class="col-checkbox" v-if="checkTrainer">
                                            <input type="checkbox" @change="checkBoxAll" v-model="all" value="0" class="styled-checkbox" title="Chọn tất cả">
                                        </th>
                                        <th class="col-candidate">Ứng viên</th>
                                        <th class="col-branch">Văn phòng</th>
                                        <th class="col-status">Trạng thái ứng viên</th>
                                        <th class="col-time">Thời gian thêm</th>
                                        <th
                                            v-for="(item, index) in listCourse"
                                            :key="index"
                                            class="col-course"
                                            :title="item.title"
                                        >
                                            <div class="course-header-title">{{ item.title }}</div>
                                        </th>
                                        <th class="col-deadline text-center">Thời hạn học đào tạo</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in listCandidate" :key="index" class="candidate-row">
                                        <td class="col-checkbox" v-if="checkTrainer">
                                            <input
                                                type="checkbox"
                                                :value="item.candidate ? item.candidate.id : ''"
                                                v-model="checkboxProp"
                                                @change="statusFilter"
                                                class="styled-checkbox"
                                            >
                                        </td>
                                        <td class="col-candidate">
                                            <div class="candidate-identity" @click="openPopCandidate(item.candidate ? item.candidate.id : '')">
                                                <div class="candidate-code-pill">
                                                    #{{ item.user ? (100000 + item.user.id) : 'N/A' }}
                                                </div>
                                                <div class="candidate-fullname" :title="item.user ? item.user.name : ''">
                                                    {{ item.user ? item.user.name : 'Không có dữ liệu' }}
                                                </div>
                                            </div>
                                        </td>
                                        <td class="col-branch">
                                            <span class="branch-badge" v-if="item.branch && (item.branch.name_alias || item.branch.name)">
                                                <i class="el-icon-office-building mr-1 text-muted"></i>
                                                {{ item.branch.name_alias ? item.branch.name_alias : item.branch.name }}
                                            </span>
                                            <span class="text-muted-dash" v-else>-</span>
                                        </td>
                                        <td class="col-status">
                                            <span
                                                v-if="item.candidate"
                                                :class="['candidate-status-pill', 'candidate-status-' + item.candidate.status]"
                                            >
                                                <span class="status-dot"></span>
                                                {{ listStatus(item.candidate.status).text }}
                                            </span>
                                            <span class="text-muted-dash" v-else>-</span>
                                        </td>
                                        <td class="col-time">
                                            <div class="date-time-box" v-if="item.candidate && item.candidate.created_at">
                                                <span class="date-text">{{ formatDateTimeParts(item.candidate.created_at).date }}</span>
                                                <span class="time-text">{{ formatDateTimeParts(item.candidate.created_at).time }}</span>
                                            </div>
                                            <span class="text-muted-dash" v-else>-</span>
                                        </td>
                                        <td
                                            v-for="(item_prop, courseIdx) in changeCourse(item.user.id)"
                                            :key="courseIdx"
                                            class="col-course text-center"
                                        >
                                            <span
                                                v-if="item_prop && (item_prop.status !== undefined)"
                                                :class="['course-status-pill', 'course-status-' + item_prop.status]"
                                            >
                                                <span class="course-dot"></span>
                                                {{ changeStatus(item_prop.status).text }}
                                            </span>
                                            <span v-else class="text-muted-dash">-</span>
                                        </td>
                                        <td
                                            v-if="!changeCourse(item.user.id)"
                                            :colspan="listCourse.length"
                                            class="text-center text-muted font-italic py-3"
                                        >
                                            Không có khóa học
                                        </td>
                                        <td class="col-deadline text-center">
                                            <span
                                                v-if="item.candidate"
                                                :class="['deadline-pill', getDeadlineClass(item.candidate.deadline)]"
                                            >
                                                <i class="el-icon-time mr-1" v-if="getDeadlineClass(item.candidate.deadline) !== 'deadline-none'"></i>
                                                {{ deadlineCandidate(item.candidate.deadline, item.candidate.id).data }}
                                            </span>
                                            <span class="text-muted-dash" v-else>-</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="total-count-badge d-flex justify-content-end mt-3 mr-2">
                            <div>
                                <span class="text-muted">Tổng số bản ghi:</span>
                                <strong class="text-primary font-weight-bold ml-1">{{ paging.total }}</strong>
                            </div>

                        </div>
                        <!-- Empty State -->
                        <div v-if="!listCandidate.length" class="empty-candidate-wrapper text-center py-5">
                            <div class="empty-icon-box mb-3">
                                <i class="el-icon-document-remove"></i>
                            </div>
                            <h5 class="font-weight-bold text-dark mb-1">Không tìm thấy ứng viên</h5>
                            <p class="text-muted small mb-0">Vui lòng thay đổi bộ lọc hoặc từ khóa tìm kiếm</p>
                        </div>

                        <!-- Table Footer / Pagination -->
                        <div class="table-footer-container d-flex justify-content-center align-items-center p-3 border-top flex-wrap gap-2">
         
                            <div class="edutalk-paging">
                                <el-pagination
                                    background
                                    @current-change="handleCurrentChange"
                                    :current-page.sync="paging.current_page"
                                    :page-size="paging.per_page"
                                    layout="prev, pager, next"
                                    :total="paging.total"
                                ></el-pagination>
                            </div>
                        </div>
                        <!-- datatable end -->
                    </div>
                </div>
            </div>
            <el-dialog :title="!check ? 'Thêm mới ứng viên' : 'Cập nhập ứng viên'" :visible.sync="dialogVisibleUngVien"
                       width="70%">
                <ValidationObserver v-slot="{  }" ref="form">
                    <form class="form" autocomplete="off">
                        <h4>Thông tin ứng viên</h4>
                        <div class="row">

                            <div class="col-6 mt-2">
                                <label>Số điện thoại:</label>
                                <ValidationProvider vid="phone" name="phone" :rules="{}" v-slot="{ errors, classes }">
                                    <el-input placeholder="Số điện thoại " v-model="dataTable.phone" :class="classes"
                                              maxlength="10"
                                              type="number" :disabled="check" @change="phoneNumberChange()"></el-input>
                                    <div class="fv-plugins-message-container">
                                        <div data-field="name" data-validator="notEmpty" class="fv-help-block">
                                            {{
                                                errors[0]
                                            }}
                                        </div>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="col-6 mt-2">
                                <label>Họ và tên:</label>
                                <ValidationProvider vid="name" name="name" :rules="{}" v-slot="{ errors, classes }">
                                    <el-input :disabled="check || checkUserExisted" placeholder="Nhập họ và tên"
                                              v-model="dataTable.name" :class="classes" maxlength="50"></el-input>
                                    <div class="fv-plugins-message-container">
                                        <div data-field="name" data-validator="notEmpty" class="fv-help-block">
                                            {{
                                                errors[0]
                                            }}
                                        </div>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="col-6 mt-2">
                                <label>Khu vực:</label>
                                <input type="text" :value="area.name" class="form-control" disabled>
                            </div>
                            <div class="col-6 mt-2">
                                <label>Văn phòng:</label>
                                <ValidationProvider vid="chi_nhanh_id" name="Ma gioi thieu" :rules="{}"
                                                    v-slot="{ errors, classes }">
                                    <el-select class="w-full" v-model="dataTable.chi_nhanh_id"
                                               :disabled="!checkTrainer">
                                        <el-option v-for="item in branch" :key="item.id"
                                                   :label="item.name_alias || item.name" :value="item.id">

                                        </el-option>
                                    </el-select>
                                    <div class="fv-plugins-message-container">
                                        <div data-field="name" data-validator="notEmpty" class="fv-help-block">
                                            {{
                                                errors[0]
                                            }}
                                        </div>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="col-6 mt-2">
                                <label>Loại ứng viên:</label>
                                <ValidationProvider vid="type" name="Loai ung vien" :rules="{}"
                                                    v-slot="{ errors, classes }">
                                    <el-select class="w-full" v-model="dataTable.type" :disabled="check">
                                        <el-option v-for="item in candidateTypes" :key="item.value" :label="item.label"
                                                   :value="item.value">
                      <span style="float: left">
                        <b>{{ item.label }}</b>
                      </span>
                                        </el-option>
                                    </el-select>
                                    <div class="fv-plugins-message-container">
                                        <div data-field="name" data-validator="notEmpty" class="fv-help-block">
                                            {{
                                                errors[0]
                                            }}
                                        </div>
                                    </div>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-12">
                                <h4>Thông tin tài khoản nội bộ</h4>
                            </div>
                            <div class="col-12 mt-2">
                                <label>Email đăng nhập: </label>
                                <ValidationProvider vid="email" name="email" :rules="{}" v-slot="{ errors, classes }">
                                    <el-input placeholder="Email" v-model="dataTable.email" :class="classes"
                                              maxlength="50"
                                    ></el-input>
                                    <div class="fv-plugins-message-container">
                                        <div data-field="name" data-validator="notEmpty" class="fv-help-block">
                                            {{
                                                errors[0]
                                            }}
                                        </div>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="col-6 mt-2" v-if="dataUpdate">
                                <label>Mật khẩu :</label>
                                <ValidationProvider vid="password" name="mat khau" :rules="{}"
                                                    v-slot="{ errors, classes }">
                                    <el-input placeholder="Mật khẩu" v-model="dataTable.password" :class="classes"
                                              type="password"
                                              show-password :disabled="!check && checkUserExisted"></el-input>
                                    <div class="fv-plugins-message-container">
                                        <div data-field="name" data-validator="notEmpty" class="fv-help-block">
                                            {{
                                                errors[0]
                                            }}
                                        </div>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="col-6 mt-2" v-if="dataUpdate">
                                <label>Nhập lại mật khẩu :</label>
                                <ValidationProvider vid="confirm_password" name="nhap lai mat khau" :rules="{}"
                                                    v-slot="{ errors, classes }">
                                    <el-input placeholder="Nhập lại mật khẩu" v-model="dataTable.confirm_password"
                                              :class="classes"
                                              type="password" show-password
                                              :disabled="!check && checkUserExisted"></el-input>
                                    <div class="fv-plugins-message-container">
                                        <div data-field="name" data-validator="notEmpty" class="fv-help-block">
                                            {{
                                                errors[0]
                                            }}
                                        </div>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div v-if="!dataUpdate" class="col-12">
                                <el-button type="text" @click="updatePass = true; dataUpdate = true">Đặt lại mật khẩu
                                </el-button>
                            </div>
                        </div>
                        <div class="d-flex dialog-footer justify-content-end mt-3">
                            <el-button @click="dialogVisibleUngVien = false">Hủy bỏ</el-button>
                            <el-button v-if="!updatePass" @click="handleSubmit()">Xác nhận</el-button>
                            <el-button v-else @click="handleSubmitUpdate()">Xác nhận</el-button>
                        </div>
                    </form>
                </ValidationObserver>
            </el-dialog>
            <el-dialog title="Import dữ liệu" :visible.sync="dialogAddMore" width="75%">
                <ValidationObserver v-slot="{ handleSubmit }" ref="form">
                    <form class="form" autocomplete="off">
                        <div class="">
                            <p>Bước 1: Tải file mẫu excel</p>
                            <button type="button" class="btn bg-orange font-weight-bold mr-2 mb-3"
                                    @click="exportExcelExample">
                                Xuất file mẫu
                            </button>
                        </div>
                        <div class="">
                            <p>Bước 2: Sau khi cập nhập dữ liệu tại file excel, tiến hành tải file lên hệ thống</p>

                            <label for="upload-input" class="btn btn-primary font-weight-bold mr-2">
                                Upload file
                                <input type="file" id="upload-input" hidden @input="changeExcelExample"
                                       placeholder="Upload file"
                                       ref="myFileInput">
                            </label>
                            <div class="mt-2">
                <span class="bg-da p-2 rounded" v-if="addFile">
                  {{ files_prop.name }}
                  <svg v-if="files_prop" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                       class="bi bi-x-circle-fill" viewBox="0 0 16 16" @click="closeFile">
                    <path
                        d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
                  </svg>
                </span>
                            </div>
                            <ValidationProvider vid="0.email_dang_nhap" name="phone" :rules="{}"
                                                v-slot="{ errors, classes }">
                                <div class="fv-plugins-message-container">
                                    <div data-field="name" data-validator="notEmpty" class="fv-help-block">
                                        {{
                                            errors[0]
                                        }}
                                    </div>
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="d-flex dialog-footer justify-content-end mt-3">
                            <el-button @click="dialogAddMore = false">Hủy bỏ</el-button>
                            <el-button  @click="importFile">Xác nhận</el-button>
                        </div>
                    </form>
                </ValidationObserver>
            </el-dialog>
            <el-dialog title="Xóa bản ghi" :visible.sync="dialogDeleteCandidate" width="30%">
                <p>Bạn chắc chắn muốn xóa <span class="bold">{{ this.checkboxProp.length }} bản ghi</span> đã chọn chứ ?
                </p>
                <p class="text-red">Lưu ý : Thao tác xóa sẽ khiến các bản ghi biến mất vĩnh viễn khỏi hệ thống .</p>
                <div class="d-flex dialog-footer justify-content-end mt-3">
                    <el-button @click="dialogDeleteCandidate = false; candidateActionValue = ''">Hủy bỏ</el-button>
                    <el-button  @click="deleteCandidate">Xác nhận</el-button>
                </div>
            </el-dialog>
            <el-dialog title="Đánh fail đào tạo" :visible.sync="dialogFailCandidate" width="30%">
                <p>Bạn chắc chắn muốn cho <span class="bold">{{ this.checkboxProp.length }} ứng viên đã chọn</span> Fail
                    đào tạo
                    chứ?</p>
                <div class="d-flex dialog-footer justify-content-end mt-3">
                    <el-button @click="dialogFailCandidate = false; candidateActionValue = ''">Hủy bỏ</el-button>
                    <el-button  @click="updateStatusCandidate">Xác nhận</el-button>
                </div>
            </el-dialog>
            <el-dialog title="Import dữ liệu" :visible.sync="logImport" width="70%">
                <p>Bước 2: Kiểm tra dữ liệu</p>
                <ValidationObserver v-slot="{ handleSubmit }" ref="form">
                    <form class="form" autocomplete="off">
                        <div class="example-preview table-responsive overflow-auto mt-3">
                            <table class="table text-left table-hover table-bordered table-vertical-center b-table">
                                <thead>
                                <tr>
                                    <th>STT</th>
                                    <th>Ứng viên</th>
                                    <th>Số điện thoại</th>
                                    <th>Email</th>
                                    <th>Kết quả</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(item, index) in listDataImport" :key="index">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ item.ho_va_ten ?? '' }}</td>
                                    <td>{{ item.so_dien_thoai ?? '' }}</td>
                                    <td>{{ item.email ?? '' }}</td>
                                    <td>
                                        <p v-if="item.success">
                                            <span class="text-green">Đạt</span>
                                        </p>
                                        <p v-if="!item.success"
                                           v-for="(item_prop, index_prop) in item?.error?.filter(d => d != null)"
                                           :key="index_prop">
                                            <span class="text-red">{{ item_prop }}</span>
                                        </p>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="d-flex dialog-footer justify-content-end mt-3">
                            <el-button @click="cancelImport">Hủy bỏ</el-button>
                            <el-button :disabled="loadingConfirm"
                                       @click="confirmImportData">
                                <i v-bind:class="[loadingConfirm ? 'el-icon-loading' : '']"></i>
                                Xác nhận
                            </el-button>
                        </div>
                    </form>
                </ValidationObserver>
            </el-dialog>
            <el-dialog title="Điểm danh học đào tạo" :visible.sync="dialog" width="75%">
                <div>
                    <div class="col-12 d-flex mb-3">
                        <div class="col-6 p-0">
                            <div>
                                <label for="">Khóa học</label>
                            </div>
                            <el-select v-model="course" @change="getCandidataAttendance">
                                <el-option v-for="item in listCourse" :key="item.id" :label="item.title"
                                           placeholder="Chọn cơ sở"
                                           :value="item.id">
                                    <span>{{ item.title }}</span>
                                </el-option>
                            </el-select>
                            <div>
                                <span class="text-red">{{ messageRequire }}</span>
                            </div>
                        </div>
                        <div class="col-6 p-0">
                            <div>
                                <label for="">Chọn văn phòng</label>
                            </div>
                            <el-select v-model="filterbranch" filterable @change="getCandidataAttendance">
                                <el-option v-for="item in listBranch" :key="item.id" :label="item.name_alias"
                                           placeholder="Chọn cơ sở"
                                           :value="item.id">
                                    <span style="float: left">{{ item.name_alias }}</span>
                                </el-option>
                            </el-select>
                            <div>
                                <span class="text-red">{{ messageRequireBranch }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="example-preview table-responsive overflow-auto mt-3">
                            <table class="table text-left table-hover table-bordered table-vertical-center b-table">
                                <thead>
                                <tr>
                                    <th scope="col">STT</th>
                                    <th scope="col">Ứng viên</th>
                                    <th scope="col">Văn phòng</th>
                                    <th scope="col">Điểm danh</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(item, index) in candidateAttendance" :key="index">
                                    <td>{{ ++index }}</td>
                                    <td>{{
                                            item.user ? 100000 + item.user.id + ' - ' + item.user.name : 'Không có dữ liệu'
                                        }}
                                    </td>
                                    <td>{{ item.branch ? item.branch.name_alias : 'Không có dữ liệu' }}</td>
                                    <td><input type="checkbox" :value="item.candidate ? item.candidate.id : ''"
                                               v-model="checkboxAttendance" @change="changeAttendance"></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="d-flex justify-content-center" v-if="!checkData">Chưa có dữ liệu</div>
                        <div>
                            <span class="text-red">{{ messageerrorAttendance }}</span>
                        </div>
                        <div class="d-flex dialog-footer justify-content-end mt-3">
                            <el-button  @click="attendance" class="bg-violet text-white p-2">Điểm danh
                            </el-button>
                        </div>
                    </div>
                </div>
            </el-dialog>

            <el-dialog
                title="Điều chuyển ứng viên"
                :visible.sync="dialogVisibleTransferCandidate"
                width="580px"
            >
                <hr>
                <dialog-transfer-candidate
                    :is_show="dialogVisibleTransferCandidate"
                    @close="dialogVisibleTransferCandidate = false; closeCheckbox()"
                    @confirm-tranfe-candidate="handleConfirmTransferCandidate"
                />
            </el-dialog>

        </div>
    </div>
</template>

<script>
import {GET_AREA} from "@/core/services/store/service.module";
import {GET_BRANCHES_ALL, GET_BRANCHES_BY_AREAS} from "@/core/services/store/center/branch.module";
import {TRAINER, STUDENT} from "@/core/config/accountTypeOption";
import {
    CREATE_CANDIDATE,
    DELETE_CANDIDATE,
    EXPORT_EXCEL,
    EXPORT_EXCEL_CANDIDATE,
    GET_CANDIDATE,
    GET_CANDIDATE_ATTENDANCE,
    GET_CANDIDATE_BY_USER_ID,
    GET_DATA_IMPORT,
    GET_USER_LOGIN,
    IMPORT_EXCEL,
    UPDATE_CANDIDATE,
    UPDATE_STATUS_CANDIDATE,
    TRANSFER_CANDIDATE,
} from "@/core/services/store/user/users.module";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {GET_USER_CANDIDATE, GET_LIST_COURSE_BY_AREA} from "@/core/services/store/course/courseLevel.module";
import {mapGetters, mapState} from "vuex";
import {read, utils} from "xlsx";
import {v4 as uuidv4} from 'uuid';
import DialogTransferCandidate from "./modal/dialogTransferCandidate.vue";

export default {
    name: "danh-sach-ung-vien",
    components: {DialogTransferCandidate},
    data() {
        return {
            checkTrainer: true,
            addFile: false,
            loadingConfirm: true,
            form: {
                keyword: '',
                status: '',
                startDate: '',
                branch_id: '',
                is_debt: 1,
            },
            result: {
                tableData: null,
            },
            pickerStartOptions: {
                disabledDate: this.disabledStartDate
            },
            pickerEndOptions: {
                disabledDate: this.disabledEndDate
            },
            listAction: [
                {
                    id: 1,
                    label: 'Gia hạn học đào tạo',
                },
                {
                    id: 4,
                    label: 'Đánh Fail đào tạo',
                },
                {
                    id: 3,
                    label: 'Xóa bản ghi',
                },
                {
                    id: 5,
                    label: 'Điều chuyển ứng viên',
                },
            ],
            statusCandidate: [
                {
                    id: 0,
                    label: 'Chưa đào tạo',
                },
                {
                    id: 1,
                    label: 'Đang học đào tạo',
                },
                {
                    id: 2,
                    label: 'Bị loại',
                },
                {
                    id: 3,
                    label: 'Hoàn thành đào tạo',
                },
            ],
            dialogVisibleUngVien: false,
            dialogAddMore: false,
            dataTable: {
                id: '',
                name: '',
                phone: '',
                khuvuc_id: '',
                email: '',
                password: '',
                confirm_password: '',
                chi_nhanh_id: '',
                dataUpdate: false,
                type: 0,
            },
            branch_id: '',
            listArea: '',
            branch: '',
            listCandidate: [],
            listBranch: {},
            currentPage: '',
            paging: {
                current_page: 1,
                per_page: 10,
                total: 0,
                link: {},
                total_pages: '',

            },
            test: '',
            checkboxProp: [],
            candidateActionValue: '',
            dataUpdate: false,
            updatePass: false,
            dialogDeleteCandidate: false,
            dialogFailCandidate: false,
            dialogVisibleTransferCandidate: false,
            files_prop: {},
            logImport: false,
            dialogAddCan: false,
            listDataImport: {},
            dataImport: [
                {
                    id: 1,
                    value: 'ho_va_ten',
                },
                {
                    id: 2,
                    value: 'so_dien_thoai',
                },
                {
                    id: 3,
                    value: 'khu_vuc',
                },
                {
                    id: 4,
                    value: 'van_phong',
                },
                {
                    id: 5,
                    value: 'email',
                },
                {
                    id: 6,
                    value: 'mat_khau',
                },
            ],
            listData: ['ho_va_ten', 'so_dien_thoai', 'khu_vuc', 'van_phong', 'email', 'mat_khau', 'is_import'],
            errorImport: {},
            area: {
                id: '',
                name: '',
                type_id: ''
            },
            checkStatusFilter: false,
            listPass: [],
            countError: 0,
            passNow: false,
            all: false,
            candidate: {},
            check: false,
            candidate_prop: {},
            prop: '',
            dialog: false,
            checkboxAttendance: [],
            course: '',
            filterbranch: '',
            checkUserExisted: false,
            candidateAttendance: {},
            closeAttendance: false,
            checkBoxClose: false,
            list_course_studying: {},
            messageerrorAttendance: '',
            checkData: false,
            listCourse: [],
            messageRequire: '',
            messageRequireBranch: '',
            courseCandidate: [],
            bgDeadline: '',
            loading: {
                table: false,
                search: false,
                save: false,
            },
            hiddenDropDown: false,
            candidateTypes: [],
            candidateTypesCentralArea: [
                {
                    "label": "Sinh viên",
                    "value": 0
                },
                {
                    "label": "Học sinh",
                    "value": 1
                },
            ],
            candidateTypesProvinceArea: [
                {
                    "label": "Full time",
                    "value": 0
                },
                {
                    "label": "Part time",
                    "value": 1
                },
                {
                    "label": "Cộng tác viên",
                    "value": 6
                },
            ],
            userExisted: {},
            originalEmail: '',
        }
    },
    mounted() {
        this.getUserLogin();
        this.getArea();
        this.getCourse();
    },

    watch: {
        dialogAddMore(value) {
            if (!value) {
                this.addFile = false;
                this.files_prop = [];
            }
        },
        dialogVisibleUngVien(newValue) {
            console.log(newValue);
        }

    },

    methods: {
        handleDropdownCommand(command) {
            if (command === 'add') {
                this.modalAdd();
            } else if (command === 'attendance') {
                this.dialog = true;
            } else if (command === 'import') {
                this.dialogAddMore = true;
            } else if (command === 'export') {
                this.exportExcelCandidate();
            }
        },
        formatDateTimeParts(value) {
            if (!value) return { date: '-', time: '' };
            const m = this.$moment(String(value));
            if (!m.isValid()) return { date: 'Không có thông tin', time: '' };
            return {
                date: m.format('DD/MM/YYYY'),
                time: m.format('HH:mm:ss')
            };
        },
        getDeadlineClass(deadline) {
            if (!deadline) return 'deadline-none';
            let now = this.$moment();
            let deadline_moment = this.$moment(deadline);
            let between = deadline_moment.diff(now);
            if (isNaN(between)) return 'deadline-none';
            if (between < 0) return 'deadline-expired';
            let diffDays = deadline_moment.diff(now, 'days');
            if (diffDays <= 2) return 'deadline-urgent';
            return 'deadline-active';
        },
        getCandidateType() {
            if (this.area.type_id === 1) { // trung tâm
                this.candidateTypes = this.candidateTypesCentralArea
            }
            if (this.area.type_id === 2) { // tỉnh
                this.candidateTypes = this.candidateTypesProvinceArea
            }
        },
        disabledStartDate(date) {
            if (this.toDate) {
                return this.toDate < date
            }
            return date > new Date();
        },
        getCandidate() {
            let params = this.mergeParams();
            this.currentPage = 1;
            this.$store.dispatch(GET_CANDIDATE, params).then((response) => {
                this.listCandidate = response.data.candidate.data;
                this.paging.total = response.data.candidate.total;
                this.paging.per_page = response.data.candidate.per_page;
                this.paging.current_page = response.data.candidate.current_page;
                this.courseCandidate = response.data.course;
            })
        },
        mergeParams(customProperties) {
            let params = {
                page: this.paging.current_page,
                per_page: this.paging.per_page,
            };
            if (this.form.startDate) {
                params = _.merge(params, {startDate: this.form.startDate})
            }
            if (this.form.keyword) {
                params = _.merge(params, {keyword: this.form.keyword.trim()})
            }
            if (this.form.status || this.form.status === 0) {
                params = _.merge(params, {status: this.form.status})
            }
            if (this.form.branch_id) {
                params = _.merge(params, {branch_id: this.form.branch_id})
            }
            if (this.area.id) {
                params = _.merge(params, {area_id: this.area.id})
            }
            params = _.merge(params, customProperties);
            params = _.merge(params, {is_debt: 1});
            return params;
        },
        exportExcelExample() {
            this.$store.dispatch(EXPORT_EXCEL, {})
                .then(() => {
            })
        },
        getArea() {
            this.$store.dispatch(GET_AREA, {}).then((response) => {
                this.listArea = response;
            })
        },
        changeBranch() {
            this.$store.dispatch(GET_BRANCHES_BY_AREAS, {area_id: this.area.id}).then((response) => {
                this.branch = response.data;
                this.listBranch = response.data;
            })
        },
        handleSubmit() {
            this.dataTable.khuvuc_id = this.area.id;
            this.$store.dispatch(CREATE_CANDIDATE, {data: {...this.dataTable, id: ''}})
                .then((response) => {
                    if (response) {
                        this.candidate_prop = response;
                        this.$message({
                            type: 'success',
                            message: 'Thêm mới ứng viên thành công',
                            showClose: true
                        })
                        this.dialogVisibleUngVien = false;
                        this.getCandidate();
                        this.changeBranch();
                    }
            }).catch((res) => {
                if (res?.data?.data.message_validate_form) {
                    this.$refs.form.setErrors(res.data.data.message_validate_form);
                }
            })
        },

        handleSubmitUpdate() {
            if (this.updatePass && !this.dataUpdate) {
                this.dataTable.password = '';
                this.dataTable.confirm_password = '';
            } else {
                this.dataTable.dataUpdate = true;
            }

            // Vẫn giữ toàn bộ dữ liệu như cũ
            const payload = {
                ...this.dataTable
            };

            const currentEmail = String(payload.email || '').trim();
            const originalEmail = String(this.originalEmail || '').trim();

            // Chỉ loại email khỏi payload khi không thay đổi
            if (currentEmail === originalEmail) {
                delete payload.email;
            } else {
                payload.email = currentEmail;
            }

            this.$store.dispatch(UPDATE_CANDIDATE, {
                data: payload
            }).then((response) => {
                if (response) {
                    this.branch = response.data;

                    this.$message({
                        type: 'success',
                        message: 'Bạn đã cập nhật ứng viên thành công',
                        showClose: true
                    });

                    this.dialogVisibleUngVien = false;
                    this.getCandidate();
                    this.changeBranch();
                }
            }).catch((response) => {
                if (response?.data?.data?.message_validate_form) {
                    this.$refs.form.setErrors(
                        response.data.data.message_validate_form
                    );
                }
            });
        },
        listStatus(status) {
            let text = 'Không có dữ liệu';
            let bg = 'bg-secondary';
            switch (Number(status)) {
                case 0:
                    text = 'Chưa đào tạo';
                    bg = 'bg-orange';
                    break;
                case 1:
                    text = 'Đang đào tạo';
                    bg = 'bg-green';
                    break;
                case 2:
                    text = 'Bị loại';
                    bg = 'bg-secondary';
                    break;
                case 3:
                    text = 'Hoàn thành đào tạo';
                    bg = 'bg-blue';
                    break;
            }
            return {
                text: text,
                bg: bg
            };
        },
        handleCurrentChange(val) {
            this.getCandidate({page: val});
        },
        handleConfirmTransferCandidate(param) {
            param.candidateIds = this.checkboxProp;
            this.$store.dispatch(TRANSFER_CANDIDATE, param).then((res) => {
                this.$message({
                    type: 'success',
                    message: res.message || 'Điều chuyển ứng viên thành công!',
                    showClose: true
                })
                this.dialogVisibleTransferCandidate =  false;
                this.closeCheckbox();
                this.getCandidate();
            }).catch((e) => {
                this.$message({
                    type: 'error',
                    message: e.message || 'Điều chuyển ứng viên thất bại!',
                    showClose: true
                })
            });
        },
        deleteCandidate() {
            this.$store.dispatch(DELETE_CANDIDATE, {
                candidateActionValue: this.candidateActionValue,
                checkboxProp: this.checkboxProp
            }).then((response) => {
                if (response.data === false) {
                    this.$message({
                        type: 'error',
                        message: 'Không thể xóa các bản ghi có trạng thái Fail đào tạo hoặc Pass',
                        showClose: true
                    })
                } else {
                    this.$message({
                        type: 'success',
                        message: response.message,
                        showClose: true
                    });
                    this.checkboxProp = [];
                }
                this.dialogDeleteCandidate = false;
                this.candidateActionValue = '';
                this.getCandidate();
            })
        },
        changeStatusCandidate() {
            if (this.checkboxProp.length) {
                if (this.candidateActionValue === 4) {
                    this.dialogFailCandidate = true;
                }

                if (this.candidateActionValue === 3) {
                    this.dialogDeleteCandidate = true;
                } else if (this.candidateActionValue === 5){
                    // 18 là id tài khoản hành chính khu vực
                    if(!this.currentUser?.account_type.id == 18) return;
                    this.dialogVisibleTransferCandidate = true;
                }
                else {
                    this.checkStatus(this.candidateActionValue, this.checkboxProp);
                    this.updateStatusCandidate();
                }
            }
        },
        updateStatusCandidate() {
            this.$store.dispatch(UPDATE_STATUS_CANDIDATE, {
                candidateActionValue: this.candidateActionValue,
                checkboxProp: this.checkboxProp
            }).then((response) => {
                if (response.data === false) {
                    this.$message({
                        type: 'error',
                        message: 'Tính năng chỉ áp dụng cho ứng viên Fail đào tạo.',
                        showClose: true
                    })
                } else if (response.data === 'no_update') {
                    this.$message({
                        type: 'error',
                        message: 'Tính năng chỉ áp dụng cho ứng viên học đào tạo.',
                        showClose: true
                    })
                } else {
                    this.getCandidate();
                    this.$message({
                        type: 'success',
                        message: 'Cập nhập trạng thái thành công',
                        showClose: true
                    });
                    this.checkboxProp = [];
                    this.dialogFailCandidate = false;
                    this.dialogDeleteCandidate = false;
                }
                this.candidateActionValue = '';
            })
        },
        checkStatus(action) {

        },
        openPopCandidate(id) {
            this.$store.dispatch(GET_CANDIDATE_BY_USER_ID, id)
                .then((response) => {
                    this.dataTable.id = id;
                    this.dataUpdate = response.data;
                    this.dataTable.name = response.data.user ? response.data.user.name : '';
                    this.dataTable.phone = response.data.user ? response.data.user.phone : '';
                    this.dataTable.email = response.data.user ? response.data.user.email : '';
                    this.originalEmail = this.dataTable.email;
                    this.dataTable.khuvuc_id = response.data.profiles && response.data.profiles.area ? response.data.profiles.area.id : '';
                    this.dataTable.chi_nhanh_id = response.data.profiles && response.data.profiles.branch ? response.data.profiles.branch.id : '';
                    this.dataTable.type = response.data.type;
                    this.dialogVisibleUngVien = true;
                    this.dataUpdate = false;
                    this.updatePass = true;
                    this.check = true;
                })
                .catch((error) => {
                    console.log(error);
                })
        },
        modalAdd() {
            this.dataTable.name = '';
            this.dataTable.phone = '';
            this.dataTable.email = '';
            this.dataTable.khuvuc_id = '';
            this.dataTable.chi_nhanh_id = '';
            this.dataTable.type = 0;
            this.dialogVisibleUngVien = true;
            this.dataUpdate = true;
            this.updatePass = false;
            this.check = false;
        },
        changeExcelExample(event) {
            this.files_prop = event.target.files ? event.target.files[0] : null;
            this.addFile = true;
        },
        async importFile() {
            if (!this.addFile) {
                return;
            }
            this.listDataImport = [];
            await this.fileToJson(this.files_prop)
                .then(dataToImport => {
                    this.logImport = true;
                    this.listDataImport = dataToImport;
                    this.validateData(dataToImport);
                })
                .catch((e) => {
                    this.$message({
                        type: 'error',
                        message: 'Có lỗi xảy ra',
                        showClose: true
                    });
                    console.log(e);
                });
        },
        validateData(dataToImport) {
            this.loadingConfirm = true;
            this.listDataImport = this.listDataImport.map((data) => {
                return {
                    ...data,
                    error: [
                        this.listDataImport.filter(c => c.so_dien_thoai == data.so_dien_thoai).length > 1 ? "Trùng số điện thoại" : null,
                        this.listDataImport.filter(c => c.email == data.email).length > 1 ? "Trùng email" : null,
                        data?.so_dien_thoai ? null : "Số điện thoại không được để trống.",
                        this.validatePhone(data?.so_dien_thoai) ? null : "Số điện thoại không hợp lệ",
                        data?.email ? null : "Email không được để trống.",
                        data?.van_phong ? null : "Văn phòng không được để trống.",
                        data?.ho_va_ten ? null : "Họ và tên không được để trống.",
                        ((data?.mat_khau ?? '') + '').length >= 6 ? null : "Mật khẩu phải có độ dài lớn hơn hoặc bằng 6",
                    ],
                }
            });
            this.$store.dispatch(GET_DATA_IMPORT, dataToImport).then((response) => {
                let errorImport = response.data;
                this.listDataImport = this.listDataImport.map((data) => {
                    var errorData = errorImport.find(d => d.so_dien_thoai === data.so_dien_thoai);
                    return {
                        ...data,
                        branch_id: errorData?.branch_id,
                        error: [
                            ...data.error,
                            errorData?.phone_error ? errorData?.phone_error : null,
                            errorData?.email_error ? errorData?.email_error : null,
                            errorData?.khu_vuc_error ? errorData?.khu_vuc_error : null,
                            errorData?.branch_id > 0 ? null : "Không tìm thấy chi nhánh " + data.van_phong,
                        ],
                        success: errorData?.phone_error == null && errorData?.email_error == null && errorData?.khu_vuc_error == null && errorData?.branch_id > 0
                            && data?.error?.every((err, index) => index <= 8 ? !err : true),
                        is_import: true
                    }
                });
                this.loadingConfirm = false;

            }).catch((res) => {
                this.loadingConfirm = false;
                console.log(res, "err GET_DATA_IMPORT");
            });
        },

        validatePhone(phone) {
            if (!/^[0-9]+$/.test(phone)) {
                return false;
            }
            return true
        },

        async importDataExcel(dataToImport) {
            this.loadingConfirm = true;
            return this.$store.dispatch(IMPORT_EXCEL, dataToImport).then((response) => {
                this.loadingConfirm = false;
                this.passNow = true;
                this.$message({
                    type: 'success',
                    message: 'Import dữ liệu thành công',
                    showClose: true
                });
                this.getCandidate();
            }).catch((res) => {
                this.loadingConfirm = false;
            })
        },
        confirmImportData() {
            if (this.listDataImport?.some(({ error }) => error?.some(c => c != null)) ?? false) return;

            this.importDataExcel(this.listDataImport).finally(d => this.cancelImport());
        },
        closeFile() {
            this.$refs.myFileInput.value = '';
            this.addFile = false;
        },
        cancelImport() {
            this.logImport = false;
            this.dialogAddMore = false;
            this.closeFile();
        },
        exportExcelCandidate() {
            let params = this.mergeParams();
            this.$store.dispatch(EXPORT_EXCEL_CANDIDATE, params).then(() => {

            })
        },
        getUserLogin() {
            try {
                let check = true;
                this.currentUser.user_positions.find((item) => {
                    if (TRAINER.includes(item.position)) {
                        check = false;
                    }
                });
                this.checkTrainer = check;
                this.$store.dispatch(GET_USER_LOGIN, {}).then((response) => {
                    this.area.id = response.data && response.data.area ? response.data.area.id : (response.data.branch ? response.data.branch.area_id : '');
                    this.area.name = response.data && response.data.area ? response.data.area.name : (response.data.branch && response.data.branch.area ? response.data.branch.area.name : '');
                    this.area.type_id = response.data && response.data.area ? response.data.area.type_id : (response.data.branch && response.data.branch.area ? response.data.branch.area.type_id : '');
                    this.dataTable.khuvuc_id = response.data && response.data.area ? response.data.area.id : (response.data.branch ? response.data.branch.area_id : '');
                    this.getCandidate();
                    this.changeBranch();
                    this.getCandidateType();
                    this.$store.dispatch(SET_BREADCRUMB, [
                        {title: "Danh sách", icon: 'far fa-sitemap'},
                        {title: "Danh sách ứng viên " + this.area.name, icon: 'far fa-chart-bar'}
                    ]);
                }).catch(error => {
                    console.error('Error in getUserLogin:', error); // Thêm catch
                })
            } catch (e) {
                console.log(e);
            }

        },
        formatDateTimeVietnam(value) {
            if (value) {
                let date = this.$moment(String(value)).format('HH:mm:ss DD-MM-YYYY')
                if (date === 'Invalid date') {
                    return 'Không có thông tin';
                }
                return date;
            }
        },
        statusFilter() {
            if (this.checkboxProp.length) {
                this.checkStatusFilter = true;
            } else {
                this.checkStatusFilter = false;
            }
            this.all = this.checkboxProp.length == this.listCandidate?.length;
        },
        checkPass(email) {
            let pass = this.listPass.includes(email);
            return pass;
        },
        closeCheckbox() {
            this.checkboxProp = [];
            this.all = false;
            this.checkStatusFilter = false;
            this.candidateActionValue = '';
        },
        checkBoxAll() {
            this.changeAllCheckbox(this.listCandidate)
        },
        changeAllCheckbox(value) {
            let arr = [];
            if (this.all) {
                this.currentPage = 1;
                value.map(function (val) {
                    arr.push(val?.candidate?.id)
                })
                this.checkboxProp = arr;
                this.checkStatusFilter = true;
            } else {
                this.checkStatusFilter = false;
                this.checkboxProp = [];
            }
        },
        changeAttendance() {

        },
        getCandidataAttendance() {
            this.$store.dispatch(GET_CANDIDATE_ATTENDANCE, {
                course: this.course,
                branch: this.filterbranch,
                area: this.area.id
            }).then((response) => {
                this.candidateAttendance = response.data;
                this.checkData = true
            })
        },
        attendance() {
            let action = 2;
            if (!this.checkboxAttendance.length) {
                this.messageerrorAttendance = 'Cần điểm danh ít nhất một ứng viên.';
                return;
            }
            if (!this.course || !this.filterbranch) {
                if (!this.course) {
                    this.messageRequire = 'Khóa học không được để trống.';
                }
                if (!this.filterbranch) {
                    this.messageRequireBranch = 'Văn phòng không được để trống';
                }
                return;
            }

            this.messageRequire = '';
            this.$store.dispatch(UPDATE_STATUS_CANDIDATE, {
                idCourse: this.course,
                candidateActionValue: action,
                checkboxProp: this.checkboxAttendance
            }).then((response) => {
                if (response.data === false) {
                    this.$message({
                        type: 'error',
                        message: 'Tính năng chỉ áp dụng cho ứng viên Fail đào tạo.',
                        showClose: true
                    })
                } else if (response.data === 'no_update') {
                    this.$message({
                        type: 'error',
                        message: 'Tính năng chỉ áp dụng cho ứng viên học đào tạo.',
                        showClose: true
                    })
                } else {
                    // this.getCandidate();
                    this.$message({
                        type: 'success',
                        message: 'Cập nhập trạng thái thành công',
                        showClose: true
                    });
                    this.checkboxAttendance = [];
                    this.getCandidataAttendance();
                    if (this.checkBoxClose) {
                        this.dialog = false;
                    }
                }
            })
        },
        getCourse() {
            this.$store.dispatch(GET_LIST_COURSE_BY_AREA, {})
                .then((response) => {
                    this.listCourse = (response?.data || []).filter(item => item != null);
                })
                .catch((response) => {
                })
        },
        deadlineCandidate(deadline, id) {
            let now = this.$moment();
            let bg = '';
            let deadline_moment = this.$moment(deadline);
            let between = deadline_moment.diff(now);
            let data = 'Còn ' + deadline_moment.diff(now, 'days') + ' ngày';
            if (between < 0) {
                data = 'Hết hạn';
                bg = 'bg-pink';
            } else {
                bg = 'bg-pink';
            }
            if (between !== between || !deadline) {
                data = 'Không có thông tin';
                bg = 'bg-pink';
            }
            this.bgDeadline = 'bg-pink';
            return {
                data: data,
                bg: bg
            };
        },
        changeStatus(status) {
            let text;
            let color;
            switch (status) {
                case 0:
                    text = 'Chưa học';
                    color = 'bg-secondary';
                    break;
                case 1:
                    text = 'Đang học';
                    color = 'bg-orange';
                    break;
                case 2:
                    text = 'Đã học';
                    color = 'bg-blue';
                    break;
                case 3:
                    text = 'Hoàn thành';
                    color = 'bg-green';
                    break;
            }
            return {text: text, color: color};
        },
        changeCourse(user_id) {
            let data = [];
            let course = this.courseCandidate.find((d) => d.userId == user_id);
            if (!course) {
                return false;
            }
            data = this.listCourse?.map((d) => course.courses.find(c => c.id == d.id) ?? {});
            return data;
        },
        fileToJson(file) {
            return new Promise((res, rej) => {
                /* Boilerplate to set up FileReader */
                const reader = new FileReader()
                reader.onload = (e) => {
                    /* Parse data */
                    const bstr = e.target.result
                    const wb = read(bstr, {type: 'binary'})
                    /* Get first worksheet */
                    const wsname = wb.SheetNames[0]

                    const ws = wb.Sheets[wsname]

                    /* Convert array of arrays */
                    const data = utils.sheet_to_json(ws)
                    /* Update state */
                    res(data.filter(d => {
                        var size = Object.keys(d).length;
                        if (size >= 2) {
                            return {...d, uid: uuidv4(), so_dien_thoai: this.repairPhone(d.so_dien_thoai)};
                        }
                    }));
                    const header = data.shift()
                }
                reader.onerror = (e) => {
                    rej(e);
                };
                reader.readAsBinaryString(file)
            });
        },
        repairPhone(phone) {
            phone = ((phone ?? "") + "").trim();
            if (phone.length >= 10 && phone[0] == "0") {
                return phone;
            }
            return "0" + phone;
        },

        phoneNumberChange() {
            this.$store.dispatch(GET_USER_CANDIDATE, {phone: this.dataTable.phone}).then((response) => {
                if (response.data.account_type_id == STUDENT || response.data.thoi_gian_nghi_viec != null || [2, 5].includes(response.data.status)) {
                    this.userExisted = response.data;
                    this.checkUserExisted = Object.values(response.data).length ? true : false;
                    this.dataTable.name = this.userExisted.name;
                    this.dataTable.email = this.userExisted.email;
                } else {
                    this.userExisted = {};
                    this.checkUserExisted = false;
                    this.$message({
                        type: 'error',
                        message: 'Số điện thoại này đã được sử dụng',
                        showClose: true
                    });
                }
            }).catch((response) => {
                this.checkUserExisted = false;
                this.userExisted = null;
                this.dataTable.name = "";
                this.dataTable.email = "";
            })
        },
    },
    computed: {
        ...mapState({
            errors: state => state.auth.errors
        }),
        ...mapGetters(['currentUser']),
    },
}
</script>

<style scoped>
/* Main Page Container */
.candidate-management-page {
    color: #1e293b;
}

/* Page Title & Main Header */
.page-main-title {
    font-size: 1.35rem;
    font-weight: 700;
    color: #1e293b;
    display: flex;
    align-items: center;
}

.btn-action-main {
    background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%) !important;
    border: none !important;
    border-radius: 8px !important;
    font-weight: 600 !important;
    padding: 9px 18px !important;
    box-shadow: 0 4px 12px rgba(79, 70, 229, 0.25) !important;
    transition: all 0.2s ease !important;
}

.btn-action-main:hover {
    box-shadow: 0 6px 16px rgba(79, 70, 229, 0.35) !important;
    transform: translateY(-1px);
}

/* Modern Card Design */
.modern-card {
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid #eef2f6;
    box-shadow: 0 4px 20px -2px rgba(50, 50, 93, 0.05), 0 2px 6px -1px rgba(0, 0, 0, 0.02);
    transition: all 0.2s ease;
}

.filter-card {
    border-top: 3px solid #6366f1;
}

.filter-field-label {
    font-size: 12px;
    font-weight: 600;
    color: #475569;
    margin-bottom: 6px;
    display: flex;
    align-items: center;
    text-transform: uppercase;
    letter-spacing: 0.3px;
}

/* Custom Element UI Input / Select Styling */
::v-deep .modern-input .el-input__inner,
::v-deep .modern-select .el-input__inner,
::v-deep .modern-date-picker.el-range-editor.el-input__inner {
    border-radius: 8px !important;
    border: 1px solid #cbd5e1 !important;
    background-color: #f8fafc !important;
    color: #1e293b !important;
    transition: all 0.2s ease !important;
}

::v-deep .modern-input .el-input__inner:focus,
::v-deep .modern-select .el-input__inner:focus,
::v-deep .modern-date-picker.is-active {
    border-color: #6366f1 !important;
    background-color: #ffffff !important;
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15) !important;
}

/* Bulk Action Banner */
.bulk-action-banner {
    background: linear-gradient(135deg, #eef2ff 0%, #f5f3ff 100%);
    border: 1px solid #c7d2fe;
    border-radius: 10px;
    margin-top: 8px;
}

.bulk-badge {
    background: #4f46e5;
    color: #ffffff;
    font-size: 13px;
    font-weight: 500;
    padding: 6px 14px;
    border-radius: 20px;
}

.bulk-action-select {
    width: 220px;
}

.btn-cancel-bulk {
    background: #ffffff !important;
    border: 1px solid #e2e8f0 !important;
    color: #64748b !important;
    border-radius: 8px !important;
    font-weight: 500 !important;
}

.btn-cancel-bulk:hover {
    color: #ef4444 !important;
    border-color: #fca5a5 !important;
    background: #fef2f2 !important;
}

/* Table Wrapper & Layout */
.candidate-table-wrapper {
    width: 100%;
    overflow-x: auto;
    position: relative;
    max-height: calc(100vh - 280px);
}

.candidate-modern-table {
    width: 100%;
    min-width: 1300px;
    border-collapse: separate;
    border-spacing: 0;
    font-size: 13px;
}

/* Table Headers */
.candidate-modern-table thead th {
    position: sticky;
    top: 0;
    z-index: 10;
    background: #f8fafc;
    color: #475569;
    font-weight: 700;
    font-size: 11.5px;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    padding: 12px 14px;
    border-bottom: 2px solid #e2e8f0;
    border-right: 1px solid #edf2f7;
    white-space: nowrap;
    vertical-align: middle;
}

.course-header-title {
    white-space: normal;
    min-width: 140px;
    max-width: 180px;
    line-height: 1.35;
    font-size: 11px;
    text-align: center;
}

/* Table Body Rows */
.candidate-modern-table tbody td {
    padding: 11px 14px;
    border-bottom: 1px solid #f1f5f9;
    border-right: 1px solid #f8fafc;
    vertical-align: middle;
    background: #ffffff;
    transition: background-color 0.15s ease;
}

.candidate-modern-table tbody tr:hover td {
    background-color: #f8fafc !important;
}

/* Sticky Column 1: Checkbox */
.col-checkbox {
    width: 46px;
    min-width: 46px;
    text-align: center;
    position: sticky !important;
    left: 0;
    z-index: 6;
    background: #ffffff;
}
.candidate-modern-table thead th.col-checkbox {
    z-index: 12;
    background: #f8fafc;
}

/* Sticky Column 2: Ứng viên */
.col-candidate {
    min-width: 230px;
    max-width: 280px;
    position: sticky !important;
    left: 46px;
    z-index: 6;
    background: #ffffff;
    border-right: 2px solid #e2e8f0 !important;
    box-shadow: 3px 0 6px -2px rgba(0, 0, 0, 0.04);
}
.candidate-modern-table thead th.col-candidate {
    z-index: 12;
    background: #f8fafc;
}

/* Column min-widths */
.col-branch {
    min-width: 150px;
}

.col-status {
    min-width: 160px;
}

.col-time {
    min-width: 150px;
}

.col-course {
    min-width: 150px;
    max-width: 200px;
}

.col-deadline {
    min-width: 150px;
}

/* Candidate Identity Cell */
.candidate-identity {
    display: flex;
    flex-direction: column;
    gap: 4px;
    cursor: pointer;
}

.candidate-code-pill {
    font-size: 11px;
    font-weight: 700;
    color: #4f46e5;
    background: #eef2ff;
    padding: 1px 7px;
    border-radius: 4px;
    display: inline-block;
    align-self: flex-start;
}

.candidate-fullname {
    font-weight: 600;
    color: #0f172a;
    font-size: 13.5px;
    transition: color 0.15s ease;
}

.candidate-identity:hover .candidate-fullname {
    color: #4f46e5;
    text-decoration: underline;
}

/* Branch Badge */
.branch-badge {
    color: #334155;
    font-weight: 500;
    font-size: 12.5px;
    display: inline-flex;
    align-items: center;
}

/* Candidate Status Pills */
.candidate-status-pill {
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
}

.status-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    margin-right: 6px;
    display: inline-block;
}

/* Status 0: Chưa đào tạo */
.candidate-status-0 {
    background: #fff7ed;
    color: #c2410c;
    border: 1px solid #fed7aa;
}
.candidate-status-0 .status-dot {
    background: #ea580c;
}

/* Status 1: Đang đào tạo */
.candidate-status-1 {
    background: #eff6ff;
    color: #1d4ed8;
    border: 1px solid #bfdbfe;
}
.candidate-status-1 .status-dot {
    background: #2563eb;
}

/* Status 2: Bị loại */
.candidate-status-2 {
    background: #fef2f2;
    color: #b91c1c;
    border: 1px solid #fecaca;
}
.candidate-status-2 .status-dot {
    background: #dc2626;
}

/* Status 3: Hoàn thành đào tạo */
.candidate-status-3 {
    background: #f0fdf4;
    color: #15803d;
    border: 1px solid #bbf7d0;
}
.candidate-status-3 .status-dot {
    background: #16a34a;
}

/* Date Time Box */
.date-time-box {
    display: flex;
    flex-direction: column;
}
.date-text {
    font-weight: 600;
    color: #334155;
    font-size: 12.5px;
}
.time-text {
    font-size: 11px;
    color: #94a3b8;
}

/* Course Progress Pills */
.course-status-pill {
    display: inline-flex;
    align-items: center;
    padding: 3px 9px;
    border-radius: 12px;
    font-size: 11.5px;
    font-weight: 600;
    white-space: nowrap;
}

.course-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 5px;
}

/* Course Status 0: Chưa học */
.course-status-0 {
    background: #f1f5f9;
    color: #64748b;
}
.course-status-0 .course-dot {
    background: #94a3b8;
}

/* Course Status 1: Đang học */
.course-status-1 {
    background: #fffbeb;
    color: #b45309;
}
.course-status-1 .course-dot {
    background: #f59e0b;
}

/* Course Status 2: Đã học */
.course-status-2 {
    background: #f0f9ff;
    color: #0369a1;
}
.course-status-2 .course-dot {
    background: #0ea5e9;
}

/* Course Status 3: Hoàn thành */
.course-status-3 {
    background: #ecfdf5;
    color: #047857;
}
.course-status-3 .course-dot {
    background: #10b981;
}

/* Deadline Pills */
.deadline-pill {
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
}

.deadline-active {
    background: #eff6ff;
    color: #2563eb;
    border: 1px solid #bfdbfe;
}

.deadline-urgent {
    background: #fff1f2;
    color: #e11d48;
    border: 1px solid #fecdd3;
    animation: pulse-soft 2s infinite;
}

.deadline-expired {
    background: #fef2f2;
    color: #991b1b;
    border: 1px solid #fecaca;
}

.deadline-none {
    background: #f8fafc;
    color: #94a3b8;
    border: 1px solid #e2e8f0;
}

@keyframes pulse-soft {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.8; }
}

.text-muted-dash {
    color: #cbd5e1;
    font-weight: bold;
}

/* Styled Checkbox */
.styled-checkbox {
    width: 16px;
    height: 16px;
    cursor: pointer;
    accent-color: #6366f1;
}

/* Dropdown Menu Item Styling */
.custom-action-dropdown .el-dropdown-menu__item {
    font-size: 13px;
    padding: 8px 16px;
    display: flex;
    align-items: center;
}

.custom-action-dropdown .el-dropdown-menu__item:hover {
    background-color: #f8fafc;
    color: #4f46e5;
}

/* Empty State */
.empty-candidate-wrapper {
    background: #ffffff;
}

.empty-icon-box {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: #f1f5f9;
    color: #94a3b8;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
}

/* Footer / Pagination */
.table-footer-container {
    background: #ffffff;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
}

.total-count-badge {
    font-size: 13px;
}

/* Dot indicators for select options */
.dot-indicator {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
}
.dot-status-0 { background: #ea580c; }
.dot-status-1 { background: #2563eb; }
.dot-status-2 { background: #dc2626; }
.dot-status-3 { background: #16a34a; }

/* Custom Scrollbar for wide tables */
.custom-scrollbar::-webkit-scrollbar {
    height: 8px;
    width: 8px;
}

.custom-scrollbar::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 4px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
}

/* Legacy helper classes compatibility */
.el-select.w-full {
    width: 100%;
}
.bg-violet {
    background: #6366f1;
}
.text-red {
    color: #ef4444;
}
.text-green {
    color: #10b981;
}
</style>
